import * as React from 'react'
import { Tag } from '../../shared/tag'

interface IProps{
  tags: string[]
  className?: string
}

export class ProductTags extends React.PureComponent<IProps> {
  /**
   * Returns an array of JSX Elements/Tag components displaying a products custom display tags
   */
  generateCustomTags = (): JSX.Element[] => {
    const filteredTags = [...this.props.tags].filter((tag: string) => (
      tag.match(/^(displaytag)(?!.*-new)/g) // only when a tag starts with 'displaytag', but not including '-new'
    ))

    return filteredTags.slice(0, 3).map((displayTag, i) => { // only display 3 tags at most
      const tagArray: string[] = displayTag.split('-')
      const tagColour: string = `#${tagArray[1]}`
      const tagText: string = tagArray[2].replace(/(_)/g, ' ')

      return <Tag key={i} color={tagColour}>{tagText}</Tag>
    })
  }

  render(): React.ReactNode {
    const customTags: JSX.Element[] = this.generateCustomTags()

    if (customTags.length === 0) {
      return null
    }


    return (
      <div className={`product-tag ${this.props.className || ''}`}>
        {customTags}
      </div>
    )
  }
}
